import { Element } from "@xmpp/xml"

export type PubSubEvent<T> = {
  type: "create" | "retract"
  item: T | { id: string } | undefined
}

export default class PubSubEventParser<T> {
  private parseItem: (item: Element) => T | undefined
  private namespace: string

  constructor(parseItem: (item: Element) => T | undefined, namespace: string) {
    this.parseItem = parseItem
    this.namespace = namespace
  }

  parse = (stanza: Element): PubSubEvent<T> | undefined => {
    const node = stanza
      .getChild("event")
      ?.getChildByAttr("node", this.namespace)
    if (!node) return

    if (node.getChild("item")) {
      return {
        type: "create",
        item: this.parseItem(node.getChild("item")!),
      }
    } else if (node.getChild("retract")) {
      return {
        type: "retract",
        item: { id: node.getChild("retract")?.getAttr("id") },
      }
    }
  }
}
